export const ALERTS = '/alertes';
export const PDF_VIEWER = '/pdfviewer';